export default __webpack_public_path__ + "static/media/banner.44ad951f.png";